// General imports
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog'; // Actualización de importación
import { MessageBoxComponent } from 'src/app/modales/message-box/message-box.component';
import { ErrorStateMatcher } from '@angular/material/core';

// Error state matcher class
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: any): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

// Service import
import { EvaluacionesService } from 'src/app/services/evaluaciones.service';

@Component({
    selector: 'app-gestor-de-historial-evaluacion-ingreso',
    templateUrl: './gestor-de-historial-evaluacion-ingreso.component.html',
    styleUrls: ['./gestor-de-historial-evaluacion-ingreso.component.scss'],
    providers: [EvaluacionesService],
    standalone: false
})
export class GestorDeHistorialEvaluacionIngresoComponent implements OnInit {
  // General properties
  public gdhei_matcher: MyErrorStateMatcher = new MyErrorStateMatcher();
  public gdhei_form: FormGroup;

  // Table properties
  public gdhei_length: number = 100;
  public gdhei_pageSize: number = 25;
  public gdhei_pageSizeOptions: number[] = [5, 10, 25, 100];
  public gdhei_page: number = 1;
  public gdhei_displayedColumns: string[] = [
    'matricula',
    'nombre',
    'eval_academica',
    'eval_psico',
    'sugerencia',
    'decision',
    'cancelar'
  ];
  public dataSource: any;

  // Action and loading state
  public gdhei_isLoading: boolean = false;

  constructor(
    private gdhei_fb: FormBuilder,
    public gdhei_dialog: MatDialog,
    private gdhei_evaluacionesService: EvaluacionesService,
    private gdhei_router: Router,
    private gdhei_route: ActivatedRoute
  ) {
    this.gdhei_form = this.gdhei_fb.group({
      buscador: new FormControl('')
    });
    this.getExpedienteConsultas(1);
  }

  ngOnInit(): void {}

  public getExpedienteConsultas(page: number) {
    this.gdhei_isLoading = true;
    this.gdhei_page = page;
    this.gdhei_evaluacionesService.getEvaluaciones(this.gdhei_page, this.gdhei_pageSize, this.gdhei_form.value.buscador).subscribe(
      response => {
        console.log(response);
        this.gdhei_isLoading = false;
        if (response.estado === 200) {
          this.gdhei_length = response.data.total;
          this.dataSource = response.data.data;
        }
      },
      error => {
        console.log(<any>error);
        this.gdhei_isLoading = false;
      }
    );
  }

  public pageEvent(event: any) {
    console.info(event);
    this.gdhei_pageSize = event.pageSize;
    this.getExpedienteConsultas(event.pageIndex + 1);
  }

  public getMatricula(matricula: any) {
    const total = 5 - matricula.toString().length;
    return '0'.repeat(total) + matricula; // Mejora en la generación de matrícula
  }

  public getEvaluacionesMod(numero_evaluacion_resultado: number, estado: string) {
    this.gdhei_isLoading = true;
    this.gdhei_evaluacionesService.getEvaluacionesMod(numero_evaluacion_resultado, estado).subscribe(
      response => {
        console.log(response);
        this.gdhei_isLoading = false;
        if (response.estado === 200) {
          this.gdhei_dialog.open(MessageBoxComponent, {
            disableClose: true,
            data: { title: "Se ha cancelado con éxito", text: "Se ha cancelado exitosamente este registro", icon: "done" }
          });
          this.getExpedienteConsultas(this.gdhei_page);
        } else {
          this.gdhei_dialog.open(MessageBoxComponent, {
            disableClose: true,
            data: { title: "Problemas al cancelar", text: "Problemas con el servicio", icon: "error_outline" }
          });
        }
      },
      error => {
        console.log(<any>error);
        this.gdhei_dialog.open(MessageBoxComponent, {
          disableClose: true,
          data: { title: "Problemas al cancelar", text: "Problemas con el servicio", icon: "error_outline" }
        });
        this.gdhei_isLoading = false;
      }
    );
  }
}
